import { SxProps, Theme } from '@mui/material/styles';
import colorConfigs from '../../configs/colorConfigs';

export const containerStyle = { 
  mt: 4, 
  mb: 4 
};

export const titleStyle = { 
  mb: 4, 
  paddingY:4, 
  fontWeight: 'bold', 
  color: colorConfigs.primary 
};

export const categoryContainerStyle = { 
  mb: 4 
};

export const categoryItemStyle = (isSelected: boolean): SxProps<Theme> => ({
  cursor: 'pointer',
  textAlign: 'center',
  p: 2,
  borderBottom: isSelected ? '2px solid' : '2px solid var(--color-transparent)',
  borderColor:isSelected ? colorConfigs.primary: '',
  fontWeight: isSelected ? 'bold' : 'normal',
});

export const categoryIconStyle: React.CSSProperties = { 
  width: 50, 
  height: 50, 
  objectFit: 'contain' 
};

export const selectedCategoryTitleStyle = { 
  mb: 2, 
  fontWeight: 'bold', 
  color: colorConfigs.primary, 
  borderStyle: 'solid', 
  borderWidth: '0px 0px 0px 4px', 
  pl: '15px' ,
};

export const cardStyle = { 
  height: '100%', 
  display: 'flex', 
  flexDirection: 'column', 
  boxShadow: 0 ,
  background: colorConfigs.secondary,
};

export const cardMediaStyle = { 
  objectFit: 'contain', 
  borderRadius: '8px' 
};

export const cardContentStyle = { 
  textAlign: 'left' 
};

export const cardTitleStyle = { 
  fontWeight: 600 
};

export const mobileMenuStyles = {
  container: (isMobile: boolean, isTablet: boolean): SxProps<Theme> => ({
    display: 'flex',
    flexDirection: 'row',
    width: isMobile ? '80%' : '75%',
    p: 0,
  }),
  categorySidebar: (isMobile: boolean, isTablet: boolean): SxProps<Theme> => ({
    width: isMobile ? '20%' : isTablet ? '15%' : '20%',
    position: 'sticky',
    top: '64px',
    height: 'calc(100vh - 64px)',
    borderRight: '1px solid var(--color-divider)',
    overflowY: 'auto',
  }),
  categoryBox: (selectedCategory: string, category: string): SxProps<Theme> => ({
    cursor: 'pointer',
    p: 1,
    textAlign: 'center',
    borderLeft: selectedCategory === category ? '3px solid ' : '3px solid var(--color-transparent)',
    borderColor: selectedCategory === category ? colorConfigs.primary : colorConfigs.transparent,
    fontWeight: selectedCategory === category ? 'bold' : 'normal',
    color: selectedCategory === category ? colorConfigs.primary : colorConfigs.tertiary,
  }),
  categoryText: {
    fontSize: '10px',
    fontWeight: 600,
    mt: 1,
    textTransform: 'capitalize',
  },
  promoImage: {
    width: '100%',
    mb: 2,
  },
  contentBox: {
    p: '16px',
  },
  categoryTitle: {
    mb: 2,
    fontWeight: 'bold',
    color: colorConfigs.primary,
    borderStyle: 'solid',
    borderWidth: '0px 0px 0px 4px',
    pl: '15px',
    lineHeight: 1,
    textTransform: 'capitalize',

  },
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: 0,
    background: colorConfigs.secondary,
  },
  cardMedia: {
    objectFit: 'contain',
  },
  cardContent: {
    textAlign: 'center',
  },
  cardTitle: {
    fontWeight: 600,
    fontSize: '12px',
  },
  cardPrice: {
    fontWeight: 500,
    fontSize: '14px',
  },
};